export default __webpack_public_path__ + "static/aboutus5-480-c37dd2a966238f612c9a3f84aaafc51a.png";